// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__22loG","organization":"styles_organization__2giuB","consultant":"styles_consultant__2PhSM"};